import ActiveFilterDTO = App.Data.Explorer.Filter.ActiveFilterDTO;

//Per-filter keys that are display-only and must not affect the data-table/graph identity or superset cache.
export const FILTER_DISPLAY_ONLY_FIELDS = [
	"isQuickFilter",
	"sortDirection",
	"sortBy",
] as const satisfies ReadonlyArray<keyof ActiveFilterDTO>;

/**
 * Returns a copy of the active filters with all display-only fields stripped,
 * so toggling them does not change a document's identity key.
 */
export const activeFiltersWithoutDisplayOnlyFields = (
	activeFilters: ActiveFilterDTO[] | undefined
): ActiveFilterDTO[] | undefined => {
	return activeFilters?.map((filter) => {
		const normalisedFilter: Partial<ActiveFilterDTO> = { ...filter };
		for (const field of FILTER_DISPLAY_ONLY_FIELDS) {
			delete normalisedFilter[field];
		}
		return normalisedFilter;
	}) as ActiveFilterDTO[] | undefined;
};
